import { NavigationGuardNext, RouteLocationNormalized } from "vue-router";
import i18n from "@/app/plugins/i18n";
import pinia from "@/shared/stores";
import { useKioskBrandingStore } from "@/kiosk/stores/kioskBranding";
import { buildKioskDocumentTitle } from "@/kiosk/utils/kioskBranding.utils";

const isKioskRoute = (to: RouteLocationNormalized): boolean => {
  const routeName = typeof to.name === "string" ? to.name : "";
  return routeName.startsWith("kiosk") || to.path.startsWith("/kiosk/");
};

export default async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
): Promise<void> => {
  const nameKey = typeof to.name === "string" ? `navBar.${to.name}` : "";
  const translatedTitle =
    nameKey && i18n.global.te(nameKey)
      ? i18n.global.t(nameKey)
      : (to.meta?.title as string) || import.meta.env.VITE_TITLE;

  if (isKioskRoute(to)) {
    const kioskBrandingStore = useKioskBrandingStore(pinia);
    document.title = buildKioskDocumentTitle(translatedTitle, kioskBrandingStore.businessName);
  } else {
    document.title = import.meta.env.VITE_TITLE.concat(" | ").concat(translatedTitle);
  }

  next();
};
